import { Popup } from '../Popup/Popup';
import { PopupProps } from '../Popup/Popup.type';
import styles from './IconPopup.module.css';

interface IconPopupProps extends PopupProps {
  error?: boolean;
  title: string;
  Icon: React.FC<any>;

}

function IconPopup({
  error,
  title,
  Icon,
  className,
  children,
  ...props
}: IconPopupProps) {
  return (
    <Popup
      className={`${styles.popup} ${styles.iconPopup} ${className} ${error ? styles.error : ''}`.trim()}
      {...props}
    >
      <div className={styles.popupIcon}>
        <Icon size={48} />
      </div>
      <h1 className={styles.popupTitle}>
        { title }
      </h1>
      { children }
    </Popup>
  );
}

IconPopup.defaultProps = {
  error: false,
};

export default IconPopup;
